import { render, staticRenderFns } from "./PopulationStatus.vue?vue&type=template&id=e3f747e0&"
import script from "./PopulationStatus.vue?vue&type=script&lang=js&"
export * from "./PopulationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports